import { createContext, useContext } from "react";
import type { IDatePickerContext } from "./types";

const DatePickerContext = createContext<IDatePickerContext | undefined>(
  undefined,
);

export const DatePickerProvider = DatePickerContext.Provider;

export const useIDatePickerContext = () => {
  const context = useContext(DatePickerContext);
  if (!context) {
    throw new Error(
      "useIDatePickerContext must be used within a DatePickerProvider",
    );
  }
  return context;
};
